import React from "react";
import Sidebar from "./../components/sidebar";
import Header from "./../components/Header";

import MainSliders from "../components/sliders/MainSliders";

const SliderScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <MainSliders/>
      </main>
    </>
  );
};

export default SliderScreen;
